import api from "../../services/axiosHeader.js";
import {draft, favoritesDossier, listInterectDoc, rating} from "../../../api/entryPoint";

export const state = {
    folders: [],
    favorites: [],
    draft: [],
    isLoading: true,
    isLoadingDraft: true,
    isLoadingFavorites: true,
    note: 0,
}

export const mutations = {
    SET_IS_LOADING(state, payload) {
        state.isLoading = payload
    },
    SET_FOLDERS(state, newValue) {
        state.folders = newValue
    },
    SET_FAVORITES(state, newValue) {
        state.favorites = newValue
    },
    SET_DRAFT(state, newValue) {
        state.draft = newValue
    },
    SET_IS_LOADING_DRAFT(state, newValue) {
        state.isLoadingDraft = newValue
    },
    SET_IS_LOADING_FAVORITES(state, newValue) {
        state.isLoadingFavorites = newValue
    },
    SET_RATING(state, newValue) {
        state.note = newValue
    }
}

export const getters = {
    getList(state) {
        return state.folders;
    },
    getFavorites(state) {
        return state.favorites;
    },
    getIsLoading(state) {
        return state.isLoading;
    },
    getDraft(state) {
        return state.draft;
    },
    getIsLoadingDraft(state) {
        return state.isLoadingDraft;
    },
    getIsLoadingFavorites(state) {
        return state.isLoadingFavorites;
    },
    getRating(state) {
        return state.note;
    }
}

export const actions = {

    // List all dossier
    list({commit, rootState}) {
        api.get(listInterectDoc)
            .then((res) => {
                commit('SET_IS_LOADING', true);
                commit('SET_FOLDERS', res.data);
                commit('SET_IS_LOADING', false);
            })
            .catch((error) => {
                console.log(error);
            });
    },
    // list favorites
    folderFavorites({commit}) {
        api.get(favoritesDossier + localStorage.userId)
            .then((res) => {
                commit('SET_IS_LOADING_FAVORITES', true);
                commit('SET_FAVORITES', res.data);
                commit('SET_IS_LOADING_FAVORITES', false);
            })
            .catch((error) => {
                console.log(error);
            });
    },
    listDraft({commit}) {
        api.get(draft)
            .then((res) => {
                commit('SET_IS_LOADING_DRAFT', true);
                commit('SET_DRAFT', res.data);
                commit('SET_IS_LOADING_DRAFT', false);
            })
            .catch((error) => {
                console.log(error);
            });
    },
    rating({commit}, payload) {
        api.get(rating + '/' + payload + '/details')
            .then((res) => {
                if (res.data!==false) {
                    commit('SET_RATING', res.data[0].note);
                } else {
                    commit('SET_RATING', 0);
                }
            }).catch((error) => {
            console.log(error);
        });
    },
}